<div
  class="page-layout-wrapper"
  [style.transform]="contentTransformStyle$ | async"
  [ngClass]="{ 'performing-animation': performingAnimation$ | async }"
>
  <div class="language-picker">
    <gd-language-picker
      [currentLocaleCode]="translationsService.currentLang"
      [isMobile]="isMobile$ | async"
      (changeLocaleCode)="onUseLocale($event)"
    >
    </gd-language-picker>
  </div>

  <div class="logo" #logo [@welcomeLogoStart]="(welcomeStart$ | async) ? 'open' : 'closed'">
    <gd-store-logo></gd-store-logo>
  </div>

  <div class="welcome" [@welcomeTextStart]="(welcomeTextStart$ | async) ? 'open' : 'closed'">
    <h1 class="welcome" data-lokalise data-key="txt_welcome_to_gelato"></h1>
  </div>
  <div
    class="page-content-wrapper"
    [@showFormStart]="(welcomeStart$ | async) ? 'open' : 'closed'"
    (@showFormStart.done)="finishAnimation()"
  >
    <router-outlet></router-outlet>
  </div>
</div>
